"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.List = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const List_1 = require("@reactionable/core/lib/crud/list/List");
const Col_1 = tslib_1.__importDefault(require("react-bootstrap/Col"));
const Container_1 = tslib_1.__importDefault(require("react-bootstrap/Container"));
const Row_1 = tslib_1.__importDefault(require("react-bootstrap/Row"));
function List(_a) {
    var { children } = _a, props = tslib_1.__rest(_a, ["children"]);
    return (jsx_runtime_1.jsx(List_1.List, Object.assign({}, props, { children: (props) => (jsx_runtime_1.jsx(Container_1.default, Object.assign({ fluid: true }, { children: jsx_runtime_1.jsx(Row_1.default, { children: jsx_runtime_1.jsx(Col_1.default, { children: children(props) }, void 0) }, void 0) }), void 0)) }), void 0));
}
exports.List = List;
//# sourceMappingURL=List.js.map